/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { addScalarDependencies } from './dependenciesAddScalar.generated.js';
import { combinationsDependencies } from './dependenciesCombinations.generated.js';
import { isIntegerDependencies } from './dependenciesIsInteger.generated.js';
import { isNegativeDependencies } from './dependenciesIsNegative.generated.js';
import { isPositiveDependencies } from './dependenciesIsPositive.generated.js';
import { largerDependencies } from './dependenciesLarger.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createComposition } from '../../factoriesAny.js';
export var compositionDependencies = {
  addScalarDependencies,
  combinationsDependencies,
  isIntegerDependencies,
  isNegativeDependencies,
  isPositiveDependencies,
  largerDependencies,
  typedDependencies,
  createComposition
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesComposition.generated.js
// module id = O2VP
// module chunks = 3